<template>
    <div class="setup-statistics-content">
        <div class="statistics-describe mg-bottom32">
            <div class="describe-title mg-bottom16">{{ liveDetail.title ? liveDetail.title : '--' }}</div>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="describe-item">
                        <div class="item-label">开播时间：</div>
                        <div class="item-text">{{ liveDetail.begin_time ? liveDetail.begin_time : '--' }}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="describe-item">
                        <div class="item-label">结束时间：</div>
                        <div class="item-text">{{ liveDetail.end_time ? liveDetail.end_time : '--' }}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="describe-item">
                        <div class="item-label">直播时长：</div>
                        <div class="item-text">{{ liveDetail.duration | formatDate }}</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="describe-item">
                        <div class="item-label">频道号：</div>
                        <div class="item-text">{{ liveDetail.id ? liveDetail.id : '--' }}</div>
                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="describe-item">
                        <div class="item-label">观看地址：</div>
                        <div class="item-text"><a :href="watchLink" class="blue" target="_blank">{{ watchLink }}</a></div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="statistics-title mg-bottom24">数据汇总</div>
        <div class="statistics-data">
            <div class="data-item">
                <div class="item-label">
                    观看次数（PV）
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">观看次数（PV）：{{liveDetail.pv}} 次<br/><br/>观看次数：播放器刷新一次算一次观看次数</div>
                        <i class="iconfont icon-icon_help"></i>
                    </el-tooltip>
                </div>
                <div class="item-number">{{liveDetail.pv}} 次</div>
            </div>
            <div class="data-item">
                <div class="item-label">
                    观看时长
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">观看时长：{{ Math.ceil(liveDetail.total_view_duration/60) }} 分钟<br/><br/>观看时长：根据每条观看记录向上取整(不足1分钟按1分钟计算)，最后再相加</div>
                        <i class="iconfont icon-icon_help"></i>
                    </el-tooltip>
                </div>
                <div class="item-number">{{ Math.ceil(liveDetail.total_view_duration/60) }} 分钟</div>
            </div>
            <div class="data-item">
                <div class="item-label">
                    观看人数（UV）
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">观看人数(UV)：{{ liveDetail.uv }} 人<br/><br/>观看人数：观众IP地址去重后的统计结果</div>
                        <i class="iconfont icon-icon_help"></i>
                    </el-tooltip>
                </div>
                <div class="item-number">{{ liveDetail.uv }} 人</div>
            </div>
            <div class="data-item">
                <div class="item-label">
                    人均观看时长
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">人均观看时长：{{ Math.ceil(Math.ceil(liveDetail.total_view_duration/60)/liveDetail.uv) ? Math.ceil(Math.ceil(liveDetail.total_view_duration/60)/liveDetail.uv) : 0 }} 分钟<br/><br/>人均观看时长=观看时长/观看人数</div>
                        <i class="iconfont icon-icon_help"></i>
                    </el-tooltip>
                </div>
                <div class="item-number">{{ Math.ceil(Math.ceil(liveDetail.total_view_duration/60)/liveDetail.uv) ? Math.ceil(Math.ceil(liveDetail.total_view_duration/60)/liveDetail.uv) : 0 }} 分钟</div>
            </div>
            <div class="data-item">
                <div class="item-label">
                    人均观看次数
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">人均观看次数:{{ Math.ceil(liveDetail.pv/liveDetail.uv) ? Math.ceil(liveDetail.pv/liveDetail.uv) : 0 }} 次<br/><br/>人均观看次数=观看次数/观看人数</div>
                        <i class="iconfont icon-icon_help"></i>
                    </el-tooltip>
                </div>
                <div class="item-number">{{ Math.ceil(liveDetail.pv/liveDetail.uv) ? Math.ceil(liveDetail.pv/liveDetail.uv) : 0 }} 次</div>
            </div>
        </div>
        <div class="statistics-title mg-bottom24">聊天记录</div>
        <div class="setup-statistics-search">
            <el-form ref="form" :inline="true" :model="queryChatParams">
                <el-form-item >
                    <el-input v-model="queryChatParams.user_id" @keypress.native.enter="chatSearch" placeholder="输入用户账号"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-input v-model="queryChatParams.username" @keypress.native.enter="chatSearch" placeholder="输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="chatSearch">搜索</el-button>
                </el-form-item>
            </el-form>
            <div class="export-data">
                <el-button type="text" class="iconfont icon-icon_export" size="small" @click="exportRecord('comment')"> 导出记录</el-button>
            </div>
        </div>
        <div class="setup-statistics-container">
            <div class="table-container">
                <el-table :data="chatTableData" border v-loading="listChatLoading">
                    <el-table-column prop="user_id" label="用户账号" min-width="60"></el-table-column>
                    <el-table-column prop="username" label="姓名" min-width="60"></el-table-column>
                    <el-table-column prop="content" label="发送内容" min-width="160"></el-table-column>
                    <el-table-column prop="comment_time" label="发送时间" min-width="100"></el-table-column>
                </el-table>
            </div>
            <div class="page-container text-align-right">
                <Pagination v-bind:child-msg="pageChatParams" @pageChange="pageChatChange" />
            </div>
        </div>
        <div class="statistics-title mg-bottom24">观看记录</div>
        <div class="setup-statistics-search">
            <el-form ref="form" :inline="true" :model="queryWatchParams">
                <el-form-item >
                    <el-input v-model="queryWatchParams.user_id" @keypress.native.enter="watchSearch" placeholder="输入用户账号"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-input v-model="queryWatchParams.username" @keypress.native.enter="watchSearch" placeholder="输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="watchSearch">搜索</el-button>
                </el-form-item>
            </el-form>
            <div class="export-data">
                <el-button type="text" class="iconfont icon-icon_export" size="small" @click="exportRecord('watch')"> 导出记录</el-button>
            </div>
        </div>
        <div class="setup-statistics-container">
            <div class="table-container">
                <el-table :data="watchTableData" border v-loading="listWatchLoading">
                    <el-table-column prop="user_id" label="用户账号" min-width="100"></el-table-column>
                    <el-table-column prop="username" label="姓名" min-width="80"></el-table-column>
                    <el-table-column prop="create_time" label="进入时间" min-width="160"></el-table-column>
                    <el-table-column prop="update_time" label="离开时间" min-width="160"></el-table-column>
                    <el-table-column label="观看时长" min-width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.duration | formatDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="region" label="地区" min-width="120"></el-table-column>
                    <el-table-column prop="client_ip" label="观众IP" min-width="120"></el-table-column>
                    <el-table-column label="观看终端" min-width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.browser | watchBrowser }}</span>
                            <!-- <span>{{ watchBrowser(scope.row.duration) }}</span> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-container text-align-right">
                <Pagination v-bind:child-msg="pageWatchParams" @pageChange="pageWatchChange" />
            </div>
        </div>
    </div>
</template>
<script>
import { getComment, getWatch, exportComment, exportWatch } from '@/api/live/index'
import Pagination from '@/components/Pagination'

export default {
    name: 'setupList',
    props: ['liveDetail'],
    data() {
        return {
            liveId: '',
            listChatLoading: false,
            queryChatParams: {
                page: 1,
                per_page: 10
            },
            chatTableData: [],
            pageChatParams: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            listWatchLoading: false,
            queryWatchParams: {
                page: 1,
                per_page: 10
            },
            watchTableData: [],
            pageWatchParams: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            watchLink: ''
        }
    },
    filters: {
        formatDate(value) {
            var result = ''
            var time = parseInt(value)
            var hr = parseInt(time / 60 / 60)
            var min = parseInt((time / 60) % 60)
            var sec = parseInt(time % 60)
            hr = hr > 9 ? hr : '0' + hr
            min = min > 9 ? min : '0' + min
            sec = sec > 9 ? sec : '0' + sec
            if (hr !== '00') {
                result = hr + ':' + min + ':' + sec
            } else {
                result = '00:' + min + ':' + sec
            }
            return result
        },
        watchBrowser(value) {
            const route = value.split('|')
            return route[0]
        }
    },
    components: {
        Pagination
    },
    created() {
        this.liveId = this.$route.query.id
        this.watchLink = window.location.origin + '/watch?channel_id=' + this.$route.query.id
        this.getComment()
        this.getWatch()
    },
    methods: {
        getComment() {
            this.listChatLoading = true
            this.queryChatParams.page = this.pageChatParams.currentPage
            this.queryChatParams.per_page = this.pageChatParams.pageSize
            getComment(this.queryChatParams, this.liveId).then(res => {
                if (res.code === 0) {
                    this.chatTableData = res.data.list
                    this.pageChatParams.total = res.data.total
                }
                this.listChatLoading = false
            }).catch((res) => {
                this.listChatLoading = false
            })
        },
        getWatch() {
            this.listWatchLoading = true
            this.queryWatchParams.page = this.pageWatchParams.currentPage
            this.queryWatchParams.per_page = this.pageWatchParams.pageSize
            getWatch(this.queryWatchParams, this.liveId).then(res => {
                if (res.code === 0) {
                    this.watchTableData = res.data.list
                    this.pageWatchParams.total = res.data.total
                }
                this.listWatchLoading = false
            }).catch((res) => {
                this.listWatchLoading = false
            })
        },
        // 分页
        pageChatChange(page) {
            this.pageChatParams.currentPage = page.currentPage
            this.pageChatParams.pageSize = page.pageSize
            this.getComment()
        },
        pageWatchChange(page) {
            this.pageWatchParams.currentPage = page.currentPage
            this.pageWatchParams.pageSize = page.pageSize
            this.getWatch()
        },
        chatSearch() {
            this.queryChatParams.page = 1
            this.pageChatParams.currentPage = 1
            this.getComment()
        },
        watchSearch() {
            this.queryWatchParams.page = 1
            this.pageWatchParams.currentPage = 1
            this.getWatch()
        },
        exportRecord(type) {
            if (type == 'comment') {
                exportComment(this.liveId).then(res => {
                    if (res.code === 0) {
                        this.download(res)
                    }
                })
            }
            if (type == 'watch') {
                exportWatch(this.liveId).then(res => {
                    if (res.code === 0) {
                        this.download(res)
                    }
                })
            }
        },
        download(res) {
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = res.data.file
            link.setAttribute('download', res.data.filename)
            document.body.appendChild(link)
            link.click()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.statistics-describe{
    .describe-title{
        font-size: 24px;
        color: #333;
        line-height: 36px;
    }
    .describe-item{
        display: flex;
        font-size: 14px;
        line-height: 24px;
        padding: 6px 0;
        .item-label{
            color: #333;
        }
        .item-text{
            flex: 1;
            color: #666;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .blue{
                color: $primaryColor;
            }
        }
    }
}
.statistics-title{
    font-size: 20px;
    color: $primaryColor;
    border-left: 3px solid $primaryColor;
    height: 20px;
    line-height: 20px;
    padding-left: 12px;
}
.statistics-data{
    background-color: #F7F8FA;
    display: flex;
    padding: 20px 0;
    margin-bottom: 48px;
    .data-item{
        flex: 1;
        text-align: center;
        position: relative;
        padding: 0 8px;
        min-width: 0;
        .item-label{
            font-size: 14px;
            font-weight: 400;
            color: #909399;
            line-height: 14px;
            i{
                font-size: 14px;
                margin-left: 8px;
            }
        }
        .item-number{
            font-size: 24px;
            color: #333;
            line-height: 24px;
            margin-top: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &:last-child{
            &::after{
                display: none;
            }
        }
        &::after{
            content: "";
            position: absolute;
            width: 1px;
            height: 32px;
            background-color: #DCDFE6;
            top: 0;
            bottom: 0;
            right: 0;
            margin: auto;
        }
    }
}
.setup-statistics-content{
    padding: 10px 0 0;
    .setup-statistics-search{
        position: relative;
        .export-data{
            position: absolute;
            right: 0;
            top: 0;
        }
    }
}
</style>
